

<script>
import { mapGetters } from 'vuex';
import BestOdds from '../../BestOdds/BestOdds.vue';
import AccordionTransition from '../common/AccordionTransition.vue';
import EventLiveBets from '../EventLiveBets.vue';
import EventSelectionFlucs from '../EventSelectionFlucs.vue';
import BookmakerOddsButton from '../../BookmakerOddsButton/BookmakerOddsButton.vue';
export default {
  name: 'EventSelectionRowMobile',
  components: {
    BestOdds,
    AccordionTransition,
    EventLiveBets,
    EventSelectionFlucs,
    BookmakerOddsButton,
  },
  props: {
    selectionData: {
      type: [Object, Array],
      required: true,
      default: () => [],
    },
    selectionFlucs: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectionLiveBets: {
      type: Array,
      required: true,
      default: () => [],
    },
    result: {
      type: String,
      required: true,
      default: () => '',
    },
    competitor: {
      type: Object,
      required: true,
    },
    competitorString: {
      type: String,
      required: true,
      default: '',
    },
    jockeyName: {
      type: String,
      required: true,
      default: '',
    },
    trainerName: {
      type: String,
      required: true,
      default: '',
    },
    odds: {
      type: Object,
      required: true,
      default: () => {},
    },
    isHarness: {
      type: Boolean,
      required: true,
      default: false,
    },
    isScratched: {
      type: Boolean,
      required: true,
      default: false,
    },
    isResulted: {
      type: Boolean,
      required: true,
      default: false,
    },
    meetingName: {
      type: String,
      required: false,
      default: '',
    },
    showBetsFlucs: {
      type: Boolean,
      required: true,
      default: false,
    },
    filters: {
      type: Object,
      required: true,
      default: () => {},
    },
    isFormGuidePage: {
      type: Boolean,
      default: true,
    },
    conversionBookmaker: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShortListed: false,
      isBlackbooked: false,
    };
  },
  computed: {
    ...mapGetters({
      selectionModalActive: 'FormGuideEventCard/getSelectionModalStatus',
    }),
    showBetsFlucsDetails() {
      return (
        (this.filters.showBets && this.selectionLiveBets.length > 0) ||
        (this.filters.showFlucs && this.selectionFlucs.length > 0)
      );
    },
    showMeetingDetails() {
      return this.meetingName !== '';
    },
    lastSixFigure() {
      const { stats } = this.selectionData;
      return stats ? stats.last_six_figure : '';
    },
    lastTenFigure() {
      const { stats } = this.selectionData;
      return stats ? stats.last_ten_figure.slice(-6) : '';
    },
    weight() {
      const { competitor } = this;
      return competitor ? `${competitor.weight}kg` : '';
    },
    conversionBookmakerOdds() {
      const { conversionBookmaker } = this;
      const bookmakerOdds = conversionBookmaker
        ? this.selectionData.bookmakerWinOdds.find(item => item.bookmakerId == conversionBookmaker.bookmakerName)
        : [];

      try {
        return bookmakerOdds ? bookmakerOdds.price.value : 0;
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    toggleShortListed() {
      this.isShortListed = !this.isShortListed;
    },
    async showSelectionModal(selectedTabIndex) {
      const { selectionData, isScratched, isFormGuidePage } = this;
      if (!isScratched && isFormGuidePage) {
        this.$store.dispatch('FormGuideEventCard/setSelectionModalData', selectionData);
        this.$store.dispatch('FormGuideEventCard/toggleSelectionModal', selectedTabIndex);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="event-selection-row-header" @click="showSelectionModal(0)">
      <div class="event-select-row-mobile__container">
        <div v-if="showMeetingDetails" class="event-select-row-mobile__race">
          <div class="event-select-row-mobile__race-container">
            <div class="event-select-row-mobile__race-name">{{ meetingName }}</div>
            <div class="event-select-row-mobile__race-time">
              <p>3m</p>
            </div>
          </div>
        </div>
        <div class="event-select-row-mobile">
          <div class="event-select-row-mobile__result">
            <div
              v-if="result > 0"
              :class="`pos-${result}`"
              class="event-select-row-mobile__result-text"
            >
              <p>{{ result }}</p>
            </div>
          </div>
          <!-- silk image -->
          <img
            v-if="selectionData.silk_image_url_medium"
            :src="selectionData.silk_image_url_medium"
            class="event-select-row-mobile__silk"
          >
          <!-- main selection info -->
          <div
            :class="{ 'no-silk': ! selectionData.silk_image_url_medium, 'bookmaker-button': !isFormGuidePage }"
            class="event-select-row-mobile-main-info"
          >
            <div class="event-select-row-mobile-main-info__row">
              <div class="event-select-row-mobile-name">{{ competitorString }}</div>
            </div>
            <div class="event-select-row-mobile-main-info__row">
              <template v-if="isHarness">
                <div class="event-select-row-mobile-main-info__column-left">
                  <div class="event-select-row-mobile-name-details">
                    <span class="highlight">D</span>
                    {{ jockeyName }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="event-select-row-mobile-main-info__column-left">
                  <div class="event-select-row-mobile-name-details">{{ weight }}</div>
                </div>
                <div class="event-select-row-mobile-main-info__column-right">
                  <div class="event-select-row-mobile-name-details">
                    <span class="highlight">J</span>
                    {{ jockeyName }}
                  </div>
                </div>
              </template>
            </div>
            <div class="event-select-row-mobile-main-info__row">
              <div class="event-select-row-mobile-main-info__column-left">
                <div class="event-select-row-mobile-name-details">
                  <template v-if="isHarness">
                    <span class="highlight">F</span>
                    {{ lastSixFigure }}
                  </template>
                  <template v-else>{{ lastTenFigure }}</template>
                </div>
              </div>
              <div class="event-select-row-mobile-main-info__column-right">
                <div class="event-select-row-mobile-name-details">
                  <span class="highlight">T</span>
                  {{ trainerName }}
                </div>
              </div>
            </div>
          </div>
          <div :class="{ 'no-icons': isHarness }" class="event-select-row-mobile-main-right">
            <div class="event-select-row-mobile-main-right__container">
              <template v-if="isFormGuidePage">
                <div
                  class="event-select-row-mobile__best-odds"
                  @click.stop
                  @click.prevent="showSelectionModal(1)"
                >
                  <BestOdds
                    v-if="!isScratched && odds"
                    :selection-id="selectionData.id"
                    :odds="odds"
                    display="movement"
                    @click.stop
                  />
                </div>
                <div v-if="!isHarness" class="event-select-row-mobile__icons">
                  <!-- blackbook image -->
                  <div v-if="isBlackbooked" class="event-select-row-mobile-blackbook"></div>
                  <!-- shortlisted image outline/filled -->
                  <a href="#" @click.stop @click.prevent="toggleShortListed">
                    <div
                      :class="[{ filled: isShortListed }, 'event-select-row-mobile-shortlisted outline']"
                    ></div>
                  </a>
                </div>
              </template>
              <template v-else>
                <BookmakerOddsButton
                  v-if="conversionBookmaker && !isScratched"
                  :bookmaker-id="conversionBookmaker.bookmakerName"
                  :bookmaker-link="conversionBookmaker.primaryBookmakerUrl"
                  :value="conversionBookmakerOdds"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!isFormGuidePage && selectionData.comments">
      <div class="event-selection-row__conversion-comment">
        <img src="https://puntcdn.com/icons/comment.svg" class="event-selection-row__comment-image" >
        <div class="event-selection-row__comment-text">{{ selectionData.comments }}</div>
      </div>
    </template>
    <!-- expandable accordion filter details (live blog bets and flucs) -->
    <AccordionTransition>
      <div v-if="showBetsFlucs" class="event-selection-row-filter-details">
        <div v-show="filters.showBets" class="event-selection-row-filter__show-bets">
          <EventLiveBets :live-bets="selectionLiveBets" :is-mobile="true" />
        </div>
        <div v-show="filters.showFlucs" class="event-selection-row-filter__show-flucs">
          <EventSelectionFlucs :selection-flucs="selectionFlucs" :is-mobile="true" />
        </div>
      </div>
    </AccordionTransition>
  </div>
</template>
